import moment from "moment";
import { Link } from "react-router-dom";
import { cn } from "../../../../utils/classnames";
import { SortIcon } from "../../modification-requests/components/Icons";


const getBookingStatus = (status, paymentStatus) => {
  console.log(status, paymentStatus)
  switch (status) {
    case "CONFIRMED":
      if (paymentStatus === "CHARGE_PENDING") {
        return {
          style: "tw:bg-[#F6BB2A]",
          text: "Pending Confirmation"
        }
      } else if (paymentStatus === "CHARGED" || paymentStatus === "ADDED_TO_MONTHLY_TOTAL" || paymentStatus === "CHARGE_INITIATED") {
        return {
          style: "tw:bg-[#3CAEA3]",
          text: "Confirmed"
        }
      } else if (paymentStatus === "CHARGE_FAILED") {
        return {
          style: "tw:bg-[#F6BB2A]",
          text: "Pending Confirmation"
        }
      }
      break;

    case "CANCELLED":
      return {
        style: "tw:bg-[#EA4335]",
        text: "Cancelled"
      }

      break;

    default:
      return {
        style: "tw:bg-[#EA4335]",
        text: "-"
      }
      break;
  }
}

const PAYMENT_STATUS_STYLES = {
  CHARGED: {
    style: "tw:bg-[#DFF9F7] tw:!text-[#3CAEA3]",
    text: "Charged"
  },
  CHARGE_FAILED: {
    style: "tw:bg-[#EA4335] tw:!text-[#FFFFFF]",
    text: "Charge Failed"
  },
  ADDED_TO_MONTHLY_TOTAL: {
    style: "tw:bg-[#DFF9F7] tw:!text-[#3CAEA3]",
    text: "Confirmed"
  },
  CHARGE_PENDING: {
    style: "tw:bg-[#FFFAF0] tw:!text-[#F2AE09]",
    text: "Pending"
  },
  CHARGE_INITIATED: {
    style: "tw:bg-[#FFFAF0] tw:!text-[#F2AE09]",
    text: "Charge Initiated"
  },
  PAID: {
    style: "tw:bg-[#4A7FB5]",
    text: "Paid"
  },
  INCOMPLETED: {
    style: "tw:bg-[#EA4335]",
    text: "Incompleted"
  },
};

const getPaymentStatus = (status) => {
  console.log(status)
  return PAYMENT_STATUS_STYLES[status] || {
    style: "tw:bg-[#EA4335]",
    text: "-"
  }
}

const DEFAULT_BADGE = "tw:bg-[#282828]";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[50px] tw:rounded-tl-[5px]" },
  { key: "bookingId", title: "Booking ID", width: "tw:w-[50px] tw:rounded-tl-[5px]" },
  { key: "name", title: "Reservastion Holder", width: "tw:w-[180px]", sortField: "customer.name" },
  { key: "userType", title: "User Type", width: "tw:w-[140px]" },
  { key: "bookingType", title: "Transfer Type", width: "tw:w-[200px]", sortField: "bookingType" },
  { key: "status", title: "Booking Status", width: "tw:w-[170px]", sortField: "bookingStatus" },
  { key: "payment", title: "Payment Status", width: "tw:w-[230px]", sortField: "paymentStatus" },
  { key: "pickup", title: "Pick-up Time", width: "tw:w-[180px]", sortField: "pickupDateTime" },
  { key: "pickupLocation", title: "Pick-up Location", width: "tw:w-[220px]", sortField: "pickupLocation.label" },
  { key: "referrer", title: "Referrer", width: "tw:w-[140px]", sortField: "referral.name" },
  { key: "cartId", title: "Cart ID", width: "tw:w-[130px]", sortField: "date" },
  { key: "createdOn", title: "Booked", width: "tw:w-[130px]", sortField: "date" },
  { key: "action", title: "Action", width: "tw:w-[120px] tw:rounded-tr-[5px]", sticky: true },
];

const TABLE_COLUMN_COUNT = TABLE_COLUMNS.length;

const baseCellClass =
  "tw:h-[75px] tw:border-b tw:border-[#F3F3F3] tw:bg-white tw:px-[15px] tw:text-[15px] tw:leading-[22px] tw:align-middle";

const getRoleText = (role, deferredPaymentEligible) => {
  if (role === "individual") return { role: "B2C", detail: "Member" };
  if (role === "business") return deferredPaymentEligible ? { role: "B2B", detail: "Deferred" } : { role: "B2B", detail: "Advance" };
  return { role: "B2C", detail: "Guest" };
};

const getLocationDetail = (loc) => {
  const formattedAddressArr = loc?.formatted_address?.split(",");
  const name = formattedAddressArr?.[0];
  const address = formattedAddressArr?.slice(1).join(",");
  return { name, address };
};

const getBookingTypeMeta = (bookingType, isAirportTransfer) => {
  if (bookingType === "byTheHour") return { label: "By The Hour" };
  if (isAirportTransfer) return { label: "Airport Transfer" };
  return { label: "Specified Destination" };
};

const Badge = ({ className, children }) => (
  <span
    className={cn(
      "tw:flex tw:w-full tw:h-[40px] tw:items-center tw:justify-center tw:whitespace-nowrap tw:rounded-[5px] tw:px-5 tw:text-[14px] tw:leading-[22px] tw:text-white",
      className,
    )}
  >
    {children}
  </span>
);

const HeaderCell = ({ title, width, sortField, sortConfig, onSort, sticky }) => {
  const sortable = !!sortField;
  const direction = sortConfig.key === sortField ? sortConfig.direction : null;

  return (
    <th
      className={cn(
        "tw:h-[60px] tw:bg-[#282828] tw:px-[15px] tw:py-[20px] tw:text-left tw:text-[15px] tw:font-bold tw:leading-[22px] tw:text-white",
        width,
        sortable && "tw:cursor-pointer tw:select-none",
        sticky && "tw:sticky tw:right-0 tw:z-20",
      )}
      onClick={sortable ? () => onSort(sortField) : undefined}
    >
      <div className={cn("tw:flex tw:items-center", sortable && "tw:justify-between")}>
        <span className="tw:whitespace-nowrap">{title}</span>
        {sortable ? <SortIcon direction={direction} /> : null}
      </div>
    </th>
  );
};

const DateTimeCell = ({ value }) => {
  const date = moment(value).locale("en");
  return (
    <div className="tw:flex tw:flex-col">
      <span className="tw:whitespace-nowrap">
        {date.format("YYYY/MM/DD")}{" "}
        <span className="tw:!text-[13px] tw:!text-[#8D8D8D]">{date.format("(ddd)")}</span>
      </span>
      <span>{date.format("H:mm")}</span>
    </div>
  );
};

const MessageRow = ({ className, text }) => (
  <tr>
    <td colSpan={TABLE_COLUMN_COUNT} className={className}>
      {text}
    </td>
  </tr>
);

const SkeletonBar = ({ className }) => (
  <span className={cn("tw:block tw:h-[16px] tw:animate-pulse tw:rounded-[4px] tw:bg-[#EDEDED]", className)} />
);

const SkeletonCell = ({ column }) => {
  switch (column.key) {
    case "status":
    case "payment":
      return <SkeletonBar className="tw:h-[40px] tw:w-full tw:rounded-[5px]" />;
    case "name":
    case "userType":
    case "pickupLocation":
      return (
        <div className="tw:flex tw:flex-col tw:gap-[8px]">
          <SkeletonBar className="tw:w-[70%]" />
          <SkeletonBar className="tw:h-[12px] tw:w-[45%]" />
        </div>
      );
    case "action":
      return <SkeletonBar className="tw:mx-auto tw:h-[30px] tw:w-[30px] tw:rounded-[2px]" />;
    case "no":
    case "bookingId":
      return <SkeletonBar className="tw:w-[60%]" />;
    default:
      return <SkeletonBar className="tw:w-[80%]" />;
  }
};

const SkeletonRows = ({ rowCount }) =>
  Array.from({ length: rowCount }).map((_, rowIndex) => (
    <tr key={`skeleton-${rowIndex}`}>
      {TABLE_COLUMNS.map((column) => (
        <td
          key={column.key}
          className={
            column.sticky
              ? "tw:sticky tw:right-0 tw:z-10 tw:h-[75px] tw:border-b tw:border-x tw:border-[#F3F3F3] tw:bg-white tw:px-[15px] tw:text-center"
              : baseCellClass
          }
        >
          <SkeletonCell column={column} />
        </td>
      ))}
    </tr>
  ));

const BookingsTable = ({ rows, sortConfig, onSort, loading = false, skeletonRowCount = 10 }) => (
  <section className="tw:mt-[34px] tw:w-full tw:overflow-x-auto">
    <table className="tw:w-full tw:min-w-[1640px] tw:border-separate tw:border-spacing-0">
      <thead>
        <tr>
          {TABLE_COLUMNS.map((column) => (
            <HeaderCell
              key={column.key}
              title={column.title}
              width={column.width}
              sortField={column.sortField}
              sortConfig={sortConfig}
              onSort={onSort}
              sticky={column.sticky}
            />
          ))}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <SkeletonRows rowCount={skeletonRowCount} />
        ) : rows.length === 0 ? (
          <MessageRow className={`${baseCellClass} tw:text-center tw:text-[#7C7B7B]`} text="No bookings found." />
        ) : (
          rows.map((row, index) => {
            const {
              _id,
              key,
              cartID,
              bookingStatus,
              bookingType,
              isAirportTransfer,
              paymentStatus,
              picuplocation,
              pickupLocation,
              pickupDateTime,
              date,
              customer,
              dataVersion = "v1",
              referral,
            } = row;

            const bookingTypeMeta = getBookingTypeMeta(bookingType, isAirportTransfer);
            const paymentProvider = paymentStatus === "paid" || paymentStatus === "incompleted" ? "stripe" : "flywire";
            const location = picuplocation !== undefined ? picuplocation : pickupLocation;
            const editPath =
              dataVersion === "v2" || dataVersion === "v3"
                ? `/admin/bookinglist/edit/v2/${_id}`
                : `/admin/bookinglist/edit/${_id}`;

            return (
              <tr key={_id}>
                <td className={baseCellClass}>{index + 1}</td>
                <td className={baseCellClass}>{`#${key}`}</td>
                <td className={baseCellClass}>{customer?.name}</td>
                <td className={baseCellClass}>
                  <div className="tw:flex tw:flex-col">
                    <span className="tw:!text-[15px] tw:!text-[#282828] tw:leading-none tw:mb-1">
                      {getRoleText(
                        customer?.user?.role,
                        customer?.user?.deferredPaymentEligible
                      ).role}
                    </span>
                    <span className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none">
                      {getRoleText(
                        customer?.user?.role,
                        customer?.user?.deferredPaymentEligible
                      ).detail}
                    </span>
                  </div>
                </td>
                <td className={baseCellClass}>
                  {bookingTypeMeta.label}
                </td>
                <td className={baseCellClass}>
                  <Badge className={getBookingStatus(bookingStatus, paymentStatus)?.style || DEFAULT_BADGE}>{getBookingStatus(bookingStatus, paymentStatus).text}</Badge>
                </td>
                <td className={baseCellClass}>
                  <Badge className={getPaymentStatus(paymentStatus)?.style || DEFAULT_BADGE}>
                    {`${getPaymentStatus(paymentStatus).text}`}
                  </Badge>
                </td>
                <td className={`${baseCellClass} tw:whitespace-nowrap`}>
                  <DateTimeCell value={pickupDateTime} />
                </td>
                <td className={baseCellClass}>
                  <div className="tw:flex tw:flex-col">
                    <span className="tw:!text-[15px] tw:!text-[#282828] tw:leading-none tw:mb-1">
                      {getLocationDetail(location).name}
                    </span>
                    <span className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none tw:block tw:max-w-[250px] tw:truncate tw:whitespace-nowrap">
                      {getLocationDetail(location).address}
                    </span>
                  </div>
                </td>
                <td className={baseCellClass}>{referral !== undefined ? referral?.name : "-"}</td>
                <td className={baseCellClass}>{`#${cartID}`}</td>
                <td className={`${baseCellClass} tw:whitespace-nowrap`}>
                  <DateTimeCell value={date} />
                </td>
                <td className="tw:sticky tw:right-0 tw:z-10 tw:h-[75px] tw:border-b tw:border-x tw:border-[#F3F3F3] tw:bg-white tw:px-[15px] tw:text-center">
                  <Link
                    to={editPath}
                    className="tw:border-0 tw:bg-transparent tw:p-0"
                    aria-label="View detail"
                  >
                    <span className="tw:!flex tw:h-[30px] tw:w-[30px] tw:!items-center tw:!justify-center tw:rounded-[2px] tw:bg-[#D4B055]">
                      <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path
                          d="M9 0.75C4.795 0.75 1.547 3.459 0.125 5.999C1.547 8.54 4.795 11.249 9 11.249C13.205 11.249 16.453 8.54 17.875 5.999C16.453 3.459 13.205 0.75 9 0.75ZM9 9.75C6.933 9.75 5.25 8.067 5.25 6C5.25 3.933 6.933 2.25 9 2.25C11.067 2.25 12.75 3.933 12.75 6C12.75 8.067 11.067 9.75 9 9.75ZM9 3.75C7.758 3.75 6.75 4.758 6.75 6C6.75 7.242 7.758 8.25 9 8.25C10.242 8.25 11.25 7.242 11.25 6C11.25 4.758 10.242 3.75 9 3.75Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </Link>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  </section>
);

export default BookingsTable;
